import React from "react";
import { Link } from "react-router-dom";
import HeaderThree from "../components/HeaderThree";
import FooterOne from "../components/FooterOne";

const NotFound = () => {
  return (
    <>
      <HeaderThree />
      <div className="container text-center py-5 my-5">
        <h1 className="display-1">404</h1>
        <h2 className="mb-4">Page Not Found</h2>
        <p>The page you are looking for doesn't exist or has been moved.</p>
        <Link to="/" className="btn btn-primary">
          Go Back Home
        </Link>
      </div>
      <FooterOne />
    </>
  );
};

export default NotFound;